(() => {
  const script = document.currentScript;
  const message = script && script.dataset.awayTitle;
  if (!message) return;

  let originalTitle = document.title;
  let lastTitle = originalTitle;
  let timer = null;

  const captureTitle = () => {
    // Keep titles updated by product variants or other page scripts.
    if (document.title !== lastTitle) originalTitle = document.title;
  };

  const alternateTitle = () => {
    captureTitle();
    lastTitle = document.title === message ? originalTitle : message;
    document.title = lastTitle;
  };

  const start = () => {
    if (timer !== null) return;
    captureTitle();
    lastTitle = document.title;
    timer = window.setInterval(alternateTitle, 1500);
  };

  const stop = () => {
    window.clearInterval(timer);
    timer = null;
    captureTitle();
    document.title = originalTitle;
    lastTitle = originalTitle;
  };

  // Visibility and focus do not interrupt the 1.5-second cycle.
  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', start);
  start();
})();
